import React, { useEffect, useState } from "react";
import styles from "../Add/addfirm.module.css";
import { get, post } from "../../../../components/api";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ReactSelect } from "../../../../components/ReactSelect";
import { useLocation, useNavigate } from "react-router-dom";
import { SweetAlert } from "../../../../helpers/helper";

const UpdateFirm = () => {
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("name is required"),
    addressLine1: Yup.string().required("addressLine1 is required"),
    addressLine2: Yup.string().required("addressLine2 is required"),
    phoneNumber: Yup.string().required("Phone Number is required"),
    gstNumber: Yup.string().required("GST Number is required"),
    city: Yup.object().required("city is required"),
    state: Yup.object().required("state is required"),
    postalCode: Yup.string().required("Postal is required"),
  });

  const location = useLocation();
  const data = location.state.data;

  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);

  const fetchCities = async () => {
    const response = await get("/all-cities", {});
    if (response.status == 200) {
      let options = response.data.map((data) => {
        return { _id: data._id, name: data.name };
      });
      setCities(options);
    }
  };
  const fetchStates = async () => {
    const response = await get("/states", {});
    if (response.status == 200) {
      let options = response.data.map((data) => {
        return { _id: data._id, name: data.name };
      });
      setStates(options);
    }
  };

  useEffect(() => {
    fetchCities();
    fetchStates();
  }, []);

  const handleUpdate = async (values, resetForm) => {
    const response = await post("admin/tms/update/firm", {
      id: data._id,
      name: values.name,
      phoneNumber: values.phoneNumber,
      gstNumber: values.gstNumber,
      address: {
        addressLine1: values.addressLine1,
        addressLine2: values.addressLine2,
        city: values.city._id,
        state: values.state._id,
        postalCode: values.postalCode,
      },
    });
    if (response.status == 200) {
      SweetAlert("Firm update Successfully", false);
      resetForm();
      navigate("/tms/Firms");
    } else {
      SweetAlert(response?.message || "error adding firm", true);
    }
  };
  return (
    <div className={styles.MainDiv}>
      <div className={styles.HeadDiv}>
        <p className={styles.Heading}> Update Firm</p>
      </div>
      <div className={styles.ContentDiv}>
        <Formik
          initialValues={{
            name: data?.name || "",
            addressLine1: data?.address?.addressLine1 || "",
            addressLine2: data?.address?.addressLine2 || "",
            phoneNumber: data?.phoneNumber || "",
            gstNumber: data?.gstNumber || "",
            city: data?.address?.city || {},
            state: data?.address?.state || {},
            postalCode: data?.address?.postalCode || "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            handleUpdate(values, resetForm);
          }}
        >
          {(formik) => {
            const { resetForm } = formik;
            return (
              <Form>
                <div className="row">
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Firm Name</label>
                    <input
                      className="form-control input-field"
                      id="name"
                      name="name"
                      placeholder="Enter Firm Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <div className="field-error ">{formik.errors.name}</div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Address Line 1</label>
                    <input
                      className="form-control input-field"
                      id="addressLine1"
                      name="addressLine1"
                      placeholder="Enter Address Line 1"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.addressLine1}
                    />
                    {formik.touched.addressLine1 &&
                    formik.errors.addressLine1 ? (
                      <div className="field-error ">
                        {formik.errors.addressLine1}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Phone Number</label>
                    <input
                      className="form-control input-field"
                      id="phoneNumber"
                      name="phoneNumber"
                      placeholder="Enter Phone Number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.phoneNumber}
                    />
                    {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                      <div className="field-error ">
                        {formik.errors.phoneNumber}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Address Line 2</label>
                    <input
                      className="form-control input-field"
                      id="addressLine2"
                      name="addressLine2"
                      placeholder="Enter Address Line 2"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.addressLine2}
                    />
                    {formik.touched.addressLine2 &&
                    formik.errors.addressLine2 ? (
                      <div className="field-error ">
                        {formik.errors.addressLine2}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Gst Number</label>
                    <input
                      className="form-control input-field"
                      id="gstNumber"
                      name="gstNumber"
                      placeholder="Enter Gst Number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.gstNumber}
                    />
                    {formik.touched.gstNumber && formik.errors.gstNumber ? (
                      <div className="field-error ">
                        {formik.errors.gstNumber}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">city</label>
                    <ReactSelect
                      name="city"
                      value={formik.values.city}
                      options={cities}
                      handleOnChange={(name, value) => {
                        return formik.setFieldValue(name, value);
                      }}
                      isSearchable={true}
                      isLoading={false}
                      noOptionsMessage="city not availables."
                      placeholder="Select city"
                    />
                    {formik.touched.city && formik.errors.city && (
                      <div className="field-error ">{formik.errors.city}</div>
                    )}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">state</label>
                    <ReactSelect
                      name="state"
                      value={formik.values.state}
                      options={states}
                      handleOnChange={(name, value) => {
                        return formik.setFieldValue(name, value);
                      }}
                      isSearchable={true}
                      isLoading={false}
                      noOptionsMessage="state not availables."
                      placeholder="Select state"
                    />
                    {formik.touched.state && formik.errors.state && (
                      <div className="field-error ">{formik.errors.state}</div>
                    )}
                  </div>
                  <div className="col-md-6 col-lg-6 col-xs-12 mb-3">
                    <label className="route-label mb-2">Postal Code</label>
                    <input
                      className="form-control input-field"
                      id="Postal"
                      name="postalCode"
                      placeholder="Enter Postal"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.postalCode}
                    />
                    {formik.touched.postalCode && formik.errors.postalCode ? (
                      <div className="field-error ">
                        {formik.errors.postalCode}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-md-12 col-lg-12 col-xs-12 mb-3">
                    <div className={styles.buttons}>
                      <button
                        type="button"
                        className={styles.CancelButton}
                        onClick={() => resetForm()}
                      >
                        Cancel
                      </button>
                      <button type="submit" className={styles.SubmitButton}>
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default UpdateFirm;
